import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent } from "ui/components/card";
import AvatarDisplay from "components/avatar/display";
import { Icon } from "components";
import { fullName } from "components/employee/utils";
import { DARKDISCORD, PHONE, FACEBOOK, LINKEDIN, WHATSAPP, TELEGRAM, SKYPE, REDIRECT } from "icons";

export default function ClientInfoCard({ client, companyHref }) {
  return (
    <div className="w-full p-8">
      <Card className="w-full max-w-7xl mx-auto p-6">
        <CardContent className="p-0">
          <div className="flex justify-between">
            <div className="flex flex-col md:flex-row gap-8 p-8">
              {/* Profile Image */}
              <div className="flex-shrink-0">
                <div className="w-32 h-32 rounded-full bg-gradient-to-br from-orange-300 to-orange-400 flex items-center justify-center overflow-hidden">
                  <div className="w-full h-full flex items-center justify-center">
                    <AvatarDisplay className="w-32 h-32" user={client} />
                  </div>
                </div>
              </div>

              {/* Main Info */}
              <div className="flex-1">
                <div className="space-y-2 mb-6">
                  <h1 className="text-3xl font-bold text-gray-900">
                    {fullName(client)}
                  </h1>
                  <p className="text-sm text-muted-foreground">
                    {client.job_title?.name}
                  </p>
                  {/* Social Icons */}
                  <div className="flex gap-3 pt-2">
                    {client.mobile_number && (
                      <a
                        href={`tel:${client.mobile_number}`}
                        className="p-2 rounded-full bg-green-100 text-green-600 hover:bg-green-200 transition-colors"
                        title="Call"
                      >
                        <Icon icon={PHONE} className="size-4" />
                      </a>
                    )}
                    {client.linkedin && (
                      <a
                        href={client.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="p-2 rounded-full bg-blue-100 text-blue-600 hover:bg-blue-200 transition-colors"
                        title="LinkedIn"
                      >
                        <Icon icon={LINKEDIN} className="size-4" />
                      </a>
                    )}
                    {client.discord && (
                      <a
                        href={`https://discord.com/users/${client.discord}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="p-2 rounded-full bg-blue-100 text-blue-800 hover:bg-blue-200 transition-colors"
                        title="Discord"
                      >
                        <Icon icon={DARKDISCORD} className="size-4" />
                      </a>
                    )}
                    {client.whatsapp && (
                      <a
                        href={`https://wa.me/${client.whatsapp}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="p-2 rounded-full bg-green-100 text-green-600 hover:bg-green-200 transition-colors"
                        title="WhatsApp"
                      >
                        <Icon icon={WHATSAPP} className="size-4" />
                      </a>
                    )}
                    {client.telegram && (
                      <a
                        href={`https://t.me/${client.telegram}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="p-2 rounded-full bg-blue-100 text-blue-600 hover:bg-blue-200 transition-colors"
                        title="Telegram"
                      >
                        <Icon icon={TELEGRAM} className="size-4" />
                      </a>
                    )}
                    {client.facebook && (
                      <a
                        href={client.facebook}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="p-2 rounded-full bg-blue-100 text-blue-600 hover:bg-blue-200 transition-colors"
                        title="Facebook"
                      >
                        <Icon icon={FACEBOOK} className="size-4" />
                      </a>
                    )}
                    {client.skype && (
                      <a
                        href={`skype:${client.skype}?chat`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="p-2 rounded-full bg-blue-100 text-blue-600 hover:bg-blue-200 transition-colors"
                        title="Skype"
                      >
                        <Icon icon={SKYPE} className="size-4" />
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Details Grid */}
            <div className="grid grid-cols-1 md:grid-cols-1 gap-6 p-10 pr-0 border-l border-gray-200 justify-center">
              <div>
                <p className="text-sm text-gray-500 mb-1">Company</p>
                <div className="flex items-center gap-2">
                  <p className="text-base text-gray-900 font-medium">
                    {client.company_id?.name}
                  </p>
                  {client.company_id?.name && companyHref && (
                    <Link
                      to={companyHref}
                      className="text-zinc-600"
                      title="Open company"
                    >
                      <Icon icon={REDIRECT} className="size-4" />
                    </Link>
                  )}
                </div>
              </div>
              <div>
                <p className="text-sm text-gray-500 mb-1">Email</p>
                <p className="text-base text-gray-900 font-medium">
                  {client.email}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500 mb-1">Phone</p>
                <p className="text-base text-gray-900 font-medium">
                  {client.mobile_number}
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
